// Redirect.js
'use strict';
import { connect } from 'react-redux';

import Redirect from '../component/Redirect.jsx';
import { replace, push } from '../action/navigationAction.js';

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    replaceState: (...data) => dispatch(replace(...data)),
    pushState: (...data) => dispatch(push(...data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Redirect);
